import React from 'react';
import styled from 'styled-components';
import PrimaryImageContext from './context';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > a {
    border-radius: 3px;
    box-shadow: 0px 2px 4px rgba(50, 50, 71, 0.06), 0px 1px 4px rgba(50, 50, 71, 0.06);
    border: 1px solid #b71e49;
    background-color: #f8f9fc;
    width: 100%;
    height: 168px;
    display: flex;
    flex-direction: column;
    align-items: center;
    :hover {
      text-decoration: none;
      border-color: #c19d3f;
    }

    > strong, > em {
      font-weight: 800;
      font-size: 14px;
      line-height: 120%;
      text-align: center;
      text-transform: uppercase;
      font-style: normal;
    }

    > strong {
      margin-top: 20px;
      color: #B71E49;
      :hover {
        color: #B71E49;
      }
    }

    > em {
      margin-top: 10px;
      :hover {
        text-decoration: underline;
      }
    }

    > .fa-picture-o {
      font-size: 48px;
      margin-top: 40px;
      color: #bbcbd8;
      :hover {
        color: #bbcbd8;
      }
    }

  }

  & > p {
    margin-top: 8px;
    color: #627484;
    font-size: 14px;
    line-height: 120%;
  }
`;

export default function Prompt() {
  const { dispatch } = React.useContext(PrimaryImageContext);

  return (
    <Container>
      <a href="#" className="sidebar-item-link" onClick={e => e.preventDefault() || dispatch({ type: 'showModal' })}>
        <span className="fa fa-picture-o" />
        <strong>no wire image</strong>
        <em>assign wire image</em>
      </a>
      <p>
        <strong>Tip:</strong>
        &nbsp;An image will increase the views your wire gets on Livewire
      </p>
    </Container>
  );
}
